"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.track = track;
exports.trackPageViewed = trackPageViewed;
exports.setUser = setUser;
exports.setApp = setApp;
exports.setSuperProperties = setSuperProperties;
exports.configure = configure;
exports.enableStateChange = enableStateChange;
exports.disableStateChange = disableStateChange;

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _stateChange = require("../logging/state-change");

var _session = require("../session");

var _constants = require("../environment/constants");

var TRAAC = _interopRequireWildcard(require("./TRAAC"));

var baseData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _session.get)().then(function (sessionBindings) {
              return {
                companyId: sessionBindings.bindings.ApplicationConfiguration.CompanyId,
                sessionId: sessionBindings.meta.SessionId,
                contactId: sessionBindings.bindings.ApplicationConfiguration.ContactId,
                testFirm: sessionBindings.bindings.ApplicationConfiguration.TestFirm === 'true'
              };
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function baseData() {
    return _ref.apply(this, arguments);
  };
}();

var stateDataPromise = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", baseData().then(function (data) {
              return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                category: 'bluemoon-event',
                label: 'custom-event'
              });
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function stateDataPromise() {
    return _ref2.apply(this, arguments);
  };
}();

var appManualConfigured = false;

function configureTRAAC() {
  return _configureTRAAC.apply(this, arguments);
}

function _configureTRAAC() {
  _configureTRAAC = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    var _yield$getSessionBind, meta, bindings, keys, _context4, items, app;

    return _regenerator.default.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (_constants.isProdType) {
              TRAAC.configuration.useProdToken();
            } else if (_constants.isLowerType) {
              TRAAC.configuration.useDevToken();
            }

            _context6.next = 3;
            return (0, _session.get)();

          case 3:
            _yield$getSessionBind = _context6.sent;
            meta = _yield$getSessionBind.meta;
            bindings = _yield$getSessionBind.bindings;
            keys = {
              server: window.location.protocol + '//' + window.location.host,
              environment: _constants.type.toLowerCase(),
              uid: meta.PrismGuid
            };

            if (!appManualConfigured) {
              items = (0, _filter.default)(_context4 = (0, _entries.default)(bindings.RoutingTable)).call(_context4, function (_ref4) {
                var _context5;

                var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
                    url = _ref5[1];

                return (0, _startsWith.default)(_context5 = window.location.href).call(_context5, url);
              });

              if (items && items.length > 1) {
                app = items[1][0];
                keys.app = app;
              }
            }

            TRAAC.register(keys);
            TRAAC.configuration.configure();

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4);
  }));
  return _configureTRAAC.apply(this, arguments);
}

var stateChangeListener;

function track(_x, _x2) {
  return _track.apply(this, arguments);
}

function _track() {
  _track = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(eventName, eventInfo) {
    var fullData, event;
    return _regenerator.default.wrap(function _callee5$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = _objectSpread2.default;
            _context7.t1 = _objectSpread2.default;
            _context7.t2 = {};
            _context7.next = 5;
            return stateDataPromise();

          case 5:
            _context7.t3 = _context7.sent;
            _context7.t4 = (0, _context7.t1)(_context7.t2, _context7.t3);
            _context7.t5 = eventInfo;
            fullData = (0, _context7.t0)(_context7.t4, _context7.t5);
            event = TRAAC.keyValue(eventName, fullData);
            TRAAC.track(function () {
              return event.build();
            });

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee5);
  }));
  return _track.apply(this, arguments);
}

function trackPageViewed(_x3, _x4, _x5) {
  return _trackPageViewed.apply(this, arguments);
}

function _trackPageViewed() {
  _trackPageViewed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(state, url, extraProps) {
    var fullData, event;
    return _regenerator.default.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.t0 = _objectSpread2.default;
            _context8.t1 = _objectSpread2.default;
            _context8.t2 = _objectSpread2.default;
            _context8.t3 = {};
            _context8.next = 6;
            return baseData();

          case 6:
            _context8.t4 = _context8.sent;
            _context8.t5 = (0, _context8.t2)(_context8.t3, _context8.t4);
            _context8.t6 = extraProps ? extraProps : {};
            _context8.t7 = (0, _context8.t1)(_context8.t5, _context8.t6);
            _context8.t8 = {};
            _context8.t9 = {
              state: state,
              page: url
            };
            fullData = (0, _context8.t0)(_context8.t7, _context8.t8, _context8.t9);
            event = TRAAC.keyValue('Page Viewed', fullData);
            TRAAC.track(function () {
              return event.build();
            });

          case 15:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _trackPageViewed.apply(this, arguments);
}

function setUser(user) {
  TRAAC.setUser(user);
}

function setApp(app) {
  appManualConfigured = true;
  TRAAC.register({
    app: app
  });
}

function setSuperProperties(props) {
  TRAAC.register(props);
}

function configure() {
  if (_constants.isProdType || _constants.isLowerType) {
    configureTRAAC().catch(console.error);
  } else {
    console.warn('Analytics should only run on lower envs or prod. Not locally');
  }
}

function enableStateChange(extraProps) {
  disableStateChange();
  stateChangeListener = (0, _stateChange.subscribe)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(state) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.t0 = trackPageViewed;
              _context3.t1 = state.substring(1);
              _context3.t2 = state;

              if (!extraProps) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return extraProps();

            case 7:
              _context3.t3 = _context3.sent;
              _context3.next = 11;
              break;

            case 10:
              _context3.t3 = {};

            case 11:
              _context3.t4 = _context3.t3;
              _context3.next = 14;
              return (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t4);

            case 14:
              _context3.next = 19;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t5 = _context3["catch"](0);
              console.warn('Error trying to log error into analytics', _context3.t5);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 16]]);
    }));

    return function (_x6) {
      return _ref3.apply(this, arguments);
    };
  }());
}

function disableStateChange() {
  if (stateChangeListener) {
    stateChangeListener();
  }
}
